export default "__VITE_ASSET__D1gtgr7r__"